var map = {
	"./button-en.png": 33633,
	"./button-es.png": 35268,
	"./change-state-en.png": 53161,
	"./change-state-es.png": 22876,
	"./massive-actions-en.png": 7089,
	"./open-notification-en.png": 26285,
	"./open-notification-es.png": 41720,
	"./options-en.png": 78515,
	"./options-es.png": 79670,
	"./selected-items-en.png": 69365,
	"./selected-items-es.png": 24592,
	"./set-alert-en.png": 30618,
	"./set-alert-es.png": 1487,
	"./set-observation-en.png": 95694,
	"./set-observation-es.png": 18875,
	"./set-responsible-en.png": 93404,
	"./set-responsible-es.png": 23689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20602;